var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { Alert, Snackbar as SnackbarMui } from '@mui/material';
import { createRoot } from 'react-dom/client';
var ID_COMPONENT = 'snackbar-generic';
export var Snackbar = function (_a) {
    var message = _a.message, _b = _a.duration, duration = _b === void 0 ? 5000 : _b, _c = _a.type, type = _c === void 0 ? 'success' : _c;
    return new Promise(function (resolve) {
        addDialog({ duration: duration, message: message, type: type }, resolve);
    });
};
export var SnackbarEvent = function (_a) {
    var duration = _a.duration, message = _a.message, type = _a.type;
    var _b = React.useState(true), open = _b[0], setOpen = _b[1];
    var handleClose = function (e, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        removeDialog();
    };
    return (_jsx(_Fragment, { children: _jsx(SnackbarMui, __assign({ open: open, autoHideDuration: duration, onClose: handleClose }, { children: _jsx(Alert, __assign({ onClose: handleClose, severity: type, sx: { width: '100%' } }, { children: message })) })) }));
};
var addDialog = function (props, resolve) {
    var body = document.getElementsByTagName('body')[0];
    var div = document.createElement('div');
    div.setAttribute('id', "".concat(ID_COMPONENT, "-container"));
    body.appendChild(div);
    var root = createRoot(div);
    root.render(_jsx(React.StrictMode, { children: _jsx(SnackbarEvent, __assign({}, props, { resolve: resolve })) }));
};
var removeDialog = function () {
    var div = document.getElementById("".concat(ID_COMPONENT, "-container"));
    var body = document.getElementsByTagName('body')[0];
    body.removeChild(div);
};
//# sourceMappingURL=Snackbar.js.map